import React, { useEffect, useMemo, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  useTheme,
} from "@mui/material";
import { useCreateNewsletterSmsClientMutation } from "../../../Api/attoDeskApi";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import { useNotifier } from "../../../Core/Notifier";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import "react-quill/dist/quill.snow.css";
import SendIcon from "@mui/icons-material/Send";
import { useLocation } from "react-router-dom";

interface FormValuesSms {
  message: string;
  clientIds: number[];
}

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const ids = query.get("ids")?.split(",").map(Number) ?? [];
  const theme = useTheme();

  const [newSms, { isLoading: creatSmsRecordLoading }] =
    useCreateNewsletterSmsClientMutation();

  const formikSms = useFormik<FormValuesSms>({
    initialValues: {
      clientIds: ids,
      message: "",
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          clientIds: values.clientIds,
          message: values.message,
        };

        const addCompanyResponse = await newSms(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          navigate(
            `/client/newsletters/sms/view/${addCompanyResponse.data.id}`
          );
          // hadelSetValuFormikSms();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValidSms = useMemo(() => {
    return formikSms.values.message && formikSms.values.clientIds.length > 0;
  }, [formikSms]);

  const handleResetSetValueFormikSms = () => {
    formikSms.setFieldValue("subject", "");
    formikSms.setFieldValue("message", "");
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <form onSubmit={formikSms.handleSubmit}>
            <Grid container>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>SMS</Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Message{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Message"
                            size="small"
                            multiline
                            rows={15}
                            {...formikSms.getFieldProps("message")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={5}>
                      <Grid
                        container
                        spacing={2}
                        justifyContent={"space-between"}
                      >
                        <Grid
                          item
                          lg={4}
                          md={6}
                          sm={12}
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        ></Grid>
                        <Grid
                          item
                          lg={8}
                          md={6}
                          sm={12}
                          xs={12}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            variant="outlined"
                            startIcon={<CloseIcon />}
                            className={classes.addButton}
                            onClick={() => handleResetSetValueFormikSms()}
                          >
                            Reset
                          </Button>
                          <Box m={0.5}></Box>

                          <Button
                            variant="contained"
                            startIcon={
                              creatSmsRecordLoading ? (
                                <CircularProgress
                                  size={18}
                                  className={classes.isLoading}
                                />
                              ) : (
                                <SendIcon />
                              )
                            }
                            className={classes.addButton}
                            onClick={() => formikSms.handleSubmit()}
                            disabled={!formValidSms || creatSmsRecordLoading}
                          >
                            Sent
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
